import Slider from 'react-slick';
import { ReactElement } from 'react';
import './Galleria.scss';

export function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
      }}
      role="button"
      aria-label="Press enter to view next item in product gallery"
      tabIndex={0}
      onClick={onClick}
      onKeyPress={onClick}
    />
  );
}

export function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
        filter: 'invert(1)',
      }}
      role="button"
      aria-label="Press enter to view next item in product gallery"
      tabIndex={0}
      onClick={onClick}
      onKeyPress={onClick}
    />
  );
}

type Props = {
  images: Record<string, any>[];
};

export default function GalleriaCustom({ images }: Props): ReactElement {
  const finalImages = images
    .sort((a, b) => a.position - b.position)
    .map(image => image.url);

  function getProductAltTest(productSrc: string) {
    if (!productSrc) return '';
    const splitSrc = productSrc
      // eslint-disable-next-line no-useless-escape
      .replace(/[\[\]?.,\/#!$%\^&\*;:{}=\\|_~()]/g, ' ')
      .split(' ');

    const lastWordOfUrl = splitSrc[splitSrc.length - 2];
    return lastWordOfUrl;
  }

  const settings = {
    customPaging(i: number) {
      return (
        <div className="slick-thumb-link">
          <img
            className="shadow-2"
            src={finalImages[i]}
            alt={`${getProductAltTest(finalImages[i])} product thumbnail`}
          />
        </div>
      );
    },

    accessibility: true,
    dotsClass: 'slick-dots slick-thumb',
    infinite: true,
    speed: 500,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    swipe: true,
    responsive: [],
  };

  return (
    <Slider {...settings} className="product-slick-slider">
      {finalImages.map(image => (
        <div className="slick-main-image" key={image}>
          <img
            src={image}
            alt={`Selected ${getProductAltTest(image)} product in gallery`}
          />
        </div>
      ))}
    </Slider>
  );
}
